import axios from 'axios'
import { LOGINAPI_ADDRESS } from 'config'
import { useCallback } from 'react'
import history from 'routerHistory'
import { UsersListState } from '../types'

export const usersFullDataList = async (accessToken: string): Promise<UsersListState> => {
  const tokenData = localStorage.getItem('bba-token') ? JSON.parse(localStorage.getItem('bba-token')) : null
  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${tokenData.token}`,
    },
  }
  const url = `${LOGINAPI_ADDRESS}/users`
  // const url = `${LOGINAPI_ADDRESS}/api/users`
  const { data } = await axios.get(url, config)
  
    if (data?.error && data.error.includes('token')) {
      localStorage.clear()
      sessionStorage.clear()
      history.push('/login')
  }

  return data
}

export const deleteUserAction = async (userId: string, accessToken: string): Promise<any> => {
  const tokenData = localStorage.getItem('bba-token') ? JSON.parse(localStorage.getItem('bba-token')) : null
  const url = `${LOGINAPI_ADDRESS}/general-profile`
  // const url = `${LOGINAPI_ADDRESS}/api/users/general-profile`
  const { data } = await axios.delete(url, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${tokenData.token}`,
    },
    data: {
      _id: userId,
    },
  })
  return data
}
